export const budgetOptions = [
  {
    label: 'budget_range_750',
    value: 'Under $750',
  },
  {
    label: 'budget_range_1500',
    value: '$750 to $1,500',
  },
  {
    label: 'budget_range_5000',
    value: '$1,500 to $5,000',
  },
  {
    label: 'budget_range_10000',
    value: '$5,000 to $10,000',
  },
  {
    label: 'budget_range_25000',
    value: '$10,000 to $25,000',
  },
  {
    label: 'budget_range_50000',
    value: '$25,000 to $50,000',
  },
  {
    label: 'budget_range_100000',
    value: '$50,000 to $100,000',
  },
  {
    label: 'budget_range_100000+',
    value: 'Above $100,000',
  },
]

export const industryOptions = [
  {
    label: 'animal_pet',
    value: 'Animal & Pet',
  },
  {
    label: 'apparel_fashion',
    value: 'Apparel, Fashion & Jewelry',
  },
  {
    label: 'arts_entertainment',
    value: 'Arts & Entertainment',
  },
  {
    label: 'attorneys_law',
    value: 'Attorneys, Law & Legal',
  },
  {
    label: 'automotive',
    value: 'Automotive (Sales & Rental)',
  },
  {
    label: 'beauty_cosmetics',
    value: 'Beauty, Cosmetics & Personal Care',
  },
  {
    label: 'career_employment',
    value: 'Career & Employment',
  },
  {
    label: 'education_coaching',
    value: 'Education, Coaching & Instruction',
  },
  {
    label: 'farming_agriculture',
    value: 'Farming, Agriculture & Sustainability',
  },
  {
    label: 'finance_banks',
    value: 'Finance, Banks, Investments & Accounting',
  },
  {
    label: 'fitness_supplements',
    value: 'Fitness, Supplements & Vitamins',
  },
  {
    label: 'health_wellness',
    value: 'Health-Related, Wellness & Medical',
  },
  {
    label: 'heavy_industry',
    value: 'Heavy Industry, Energy & Manufacturing',
  },
  {
    label: 'insurance',
    value: 'Insurance',
  },
  {
    label: 'logistics',
    value: 'Logistics & Transportation',
  },
  {
    label: 'marketing_advertising',
    value: 'Marketing, Advertising, PR & Digital Services',
  },
  {
    label: 'pharma',
    value: 'Pharma',
  },
  {
    label: 'real_estate',
    value: 'Real Estate',
  },
  {
    label: 'restaurants_food',
    value: 'Restaurants, Foods & Beverages',
  },
  {
    label: 'travel_hotel',
    value: 'Travel, Hotel & Tourism',
  },
  {
    label: 'other_industry',
    value: 'Other',
  },
  {
    label: 'e_commerce',
    value: 'E-commerce',
  },
  {
    label: 'healthcare',
    value: 'Healthcare',
  },
  {
    label: 'services_contractors',
    value:
      'Professional Services & Contractors (Cleaners, HVAC, Plumbers, etc.)',
  },
  {
    label: 'saas_it',
    value: 'SaaS, IT & Software',
  },
  {
    label: 'decor_furniture_improvement',
    value: 'House Decor, Furniture, Home Improvement',
  },
]

export const challengesOptions = [
  {
    label: 'challenges_awareness_traffic',
    value: 'Need more awareness and traffic',
  },
  {
    label: 'challenges_few_leads',
    value: 'Not enough leads',
  },
  {
    label: 'challenges_low_conversion',
    value: 'Leads not converting into sales',
  },
  {
    label: 'challenges_strategy',
    value: 'The current strategy is not working',
  },
  {
    label: 'challenges_mix',
    value: 'A mix of the above',
  },
]
export const urgencyOptions = [
  {
    label: 'urgency_immediately',
    value: 'I need help IMMEDIATELY',
  },
  {
    label: 'urgency_this_quarter',
    value: 'I need to start working on it THIS QUARTER',
  },
  {
    label: 'urgency_six_months',
    value: 'I have 6 MONTHS to decide',
  },
  {
    label: 'urgency_one_year',
    value: 'I have more than A YEAR',
  },
  {
    label: 'urgency_diy',
    value: 'Gathering information for DIY',
  },
  {
    label: 'urgency_not_priority',
    value: 'Not a priority',
  },
]
export const businessTypesOptions = [
  {
    label: 'e_commerce',
    value: 'E-commerce',
  },
  {
    label: 'professional_services',
    value: 'Professional Services',
  },
  {
    label: 'saas',
    value: 'SaaS',
  },
  {
    label: 'other_industry',
    value: 'Other',
  },
]
export const numberOfEmployeesOptions = [
  {
    label: 'employees_5',
    value: '1 - 5',
  },
  {
    label: 'employees_25',
    value: '6 - 25',
  },
  {
    label: 'employees_100',
    value: '26 - 100',
  },
  {
    label: 'employees_above_100',
    value: '100+',
  },
]

export const marketingTeamSizeOptions = [
  {
    label: 'marketing_team_size_zero',
    value: 'I don’t have a marketing team',
  },
  {
    label: 'marketing_team_size_one',
    value: '1 person',
  },
  {
    label: 'marketing_team_size_plural',
    variable: '2-5',
    value: '2-5 people',
  },
  {
    label: 'marketing_team_size_plural',
    variable: '6-10',
    value: '6-10 people',
  },
  {
    label: 'marketing_team_size_plural',
    variable: '10+',
    value: '10+ people',
  },
]

// if budget is less than $1500
export const shouldShowChallenges = (budget) =>
  budget === budgetOptions[0].value || budget === budgetOptions[1].value
